
import ROUTES from '@utils/routes';
import { SELLING_PACKS_TEMPLATE_LIST } from '@utils/globals';

export const STRINGS = {
    campaign: "Dark Pinup",

    ribbon: "The first authentic photography NFT collection by Lars Kommienezuspadt. Available exclusively on WAX.",

    resourcesPage: {
        resourcesTitle: 'Available Resources',
        cpuAvailable: "CPU Available",
        netAvailable: "NET Available",
        ramAvailable: "RAM Available",
        stakeCpu: "Stake CPU",
        amountOfCpuToStake: "Amount of CPU to Stake in Wax",
        net: "NET",
        stakeNet: "Stake Net",
        amountOfNetToStake: "Amount of Net to Stake in Wax",
        ram: "RAM",
        buyRam: "Buy RAM",
        amountOfRamToBuy: "Amount of RAM to Buy in Wax",
        successCPU: 'CPU successfully staked',
        successNET: 'NET successfully staked',
        successRAM: 'RAM successfully purchased',
        availableFunds: 'Your available balance is'
    },

    probabilities: [
        {
            template_id: SELLING_PACKS_TEMPLATE_LIST[0],
            packContent: '25 Cards',
            title: "Probabilities",
            probabilities:
            [
                { rarity: 'Base', probability: '24.444%' },
                { rarity: 'Noir', probability: '24.444%' },
                { rarity: 'Print', probability: '15.556%' },
                { rarity: 'Memento', probability: '15.556%' },
                { rarity: 'Artist Signature', probability: '6.667%' },
                { rarity: 'Model Mark', probability: '6.667%' },
                { rarity: 'Prismatallic', probability: '6.071%' },
                { rarity: 'Candlelight', probability: '.606%' },
                { rarity: 'Noir Physical Packs', note: "additional chance (Full Pack - 5 Total) | 1.01% (Collector's Box - 20 Total)", probability: '.51%' },
                { rarity: 'Paintings and Camera', probability: '100%' }
            ]
        }
    ],

    actOneProbabilities: [
        {
            template_id: SELLING_PACKS_TEMPLATE_LIST[0],
            packContent: '25 Cards',
            title: "Probabilities",
            subtitle: "Same across packs and boxes",
            probabilities:
            [
                { rarity: 'Base', probability: '24.444%' },
                { rarity: 'Noir', probability: '24.444%' },
                { rarity: 'Print', probability: '15.556%' },
                { rarity: 'Memento', probability: '15.556%' },
                { rarity: 'Artist Signature', probability: '6.667%' },
                { rarity: 'Model Mark', probability: '6.667%' },
                { rarity: 'Prismatallic', probability: '6.061%' },
                { rarity: 'Candlelight', probability: '.606%' },
                { rarity: 'Special Memento', note: "additional chance (Full Pack - 5 Total) | 1.01% (Collector's Box - 20 Total)", probability: '.51%' },
                { rarity: 'Special Candlelight', note: "(Collector's Box)", probability: '100%' }
            ]
        }
    ],

    rank: "Rank",
    account: "Account",
    name: "Name",
    points: "Points",
    emberScore: "Ember Score",
    emberPacks: "Ember Packs",
    emberScoreChartTitle: "Ember Score Chart",

    emberEventTitle: "The Ember Burn Event",
    emberEventDescriptionTitle: "What are the points earned per asset?",
    emberEventDescription: "This is the breakdown of the points earned by burning your Dark Pinup cards. The points earned are structured to be fair, with special incentives given to those that purchased and earned Special Candlelights, Wrappers, as well as Burnt Flyers. Everyone is rewarded for participating in this burn event. Special favor will be bestowed upon the top 10, with differing prizes for participants closest to rank #1.",

    emberEventDescriptionTitle2: "Where can I get more info?",
    emberEventDescription2: <>Find more information on the Ember Burn event in the blog post <a href="https://facings.medium.com/dark-pinup-ember-burn-event-6f5de39c77b2" target='_blank' rel='noreferrer noopener' >here</a>. Cards can be burned from the <a href={`/#${ROUTES.inventory}`}>inventory page</a></>,

    emberEventDescriptionTitle3: "How can I acquire more items to burn?",
    emberEvent: "Ember Event",
    event: "Act Two Coming November 30",
    eventDescription: <>
        <ul style={{ padding: 0 }}>
            <li>9 beautiful rarities</li>
            <li>Time unlocked crafting</li>
            <li>Roadmap</li>
            <li>New utility</li>
        </ul>
    </>,

    burntPacks: "Burnt packs/boxes do NOT contain NFTs",
    burntPacksFuture: "Filters for Full Pack's & Collector's Boxes coming soon",

    roadmap: "Roadmap",
    salesProgress: [{
        percentage: "25% Sold",
        items: <ul><li>First crafting scene recipes unlocked</li></ul>
    },
    {
        percentage: "50% Sold",
        items: <ul><li>Special NFTs airdropped</li><li>Exclusive AMA with a model from Dark Pinup</li></ul>
    },
    {
        percentage: "75% Sold",
        items: <ul><li>Special Journal NFT airdropped</li><li>Physical Noir pack crafting recipe unlocked</li></ul>
    },
    {
        percentage: "100% Sold",
        items: <ul><li>To Be Announced!</li></ul>
    }],
    craftPage: {
        confirmationTitle: 'Are you sure you want to craft?',
        confirmationDescription: "All selected items will be burned. This cannot be undone.",
        description: <>
            <ol>
                <li>
                    Combine NFTs from Dark Pinup Act Two to create new cards from the four Scenes available through a time based unlock system
                </li>
                <li>
                    Each Scene will unlock after 2-3 weeks. A Countdown timer will indicate when each Scene will unlock.
                </li>
                <li>
                    The first Scene will start when 25% of packs have been sold.
                </li>
                <li>
                    Each scene contains a subset of a special photo shoot containing one new model across three variants.
                </li>
                <li>
                    Additional recipes for physical Noir packs can also be unlocked as well as additional surprises.
                </li>
            </ol>
        </>
    },

    craftBuyPacks: 'Buy Packs',
    craftButton: 'Craft',
    selectMintNumbers: 'Select Mint Numbers',

    packsOnly: "Packs Only",
    cardsOnly: "Cards Only",
    allAssets: "All Assets",
    redeemable: "Redeemable",
    noAssetsFound: "No Assets Found",
    variantFilter: 'Variant Filter',
    rarityFilter: 'Rarity Filter',
    cardIdFilter: 'Card Id Filter',

    howToBuyHeadline: 'How to Buy Dark Pinup NFTs',
    rarities: "Rarities",

    home: "Home",
    packRips: "Pack Rips",
    inventory: "Inventory",
    leaderboard: "Leaderboard",
    faq: "FAQ",
    news: "News",
    craft: "Craft",
    resources: "Resources",
    fiatPurchases: "Fiat Purchases",
    actOne: "Act One",
    vivaPacks: "Viva Packs",

    totalPacksMessage: "{0} Ember Packs in total",
    totalPointsMessage: "{0} Points earned in total",

    logIn: "Log In",
    logOut: "Log Out",
    notFound: "Not Found",
    loading: "Loading",
    loadingEl: "Loading...",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    error: "Error",
    defaultErrorMessage: "An error has occurred!",

    goToHome: "Home Page",

    day: "day",
    days: "days",
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    second: "second",
    seconds: "seconds",

    available: "available",
    notSupportedCreaditCards: "No Discover Card",
    reservedPacks: "Packs are reserved during the checkout process",

    shop: "Shop",
    buyPack: "Buy Pack",
    buyBox: "Buy VIP Pass",
    buyPacks: "Buy Packs",
    buyBoxes: "Buy VIP Passes",
    buyAPack: "Buy a Pack",
    buyABox: "Buy a VIP Pass",
    buyMorePacks: "Buy more Packs",
    singlePack: "Pack",
    packsAmount: "Packs amount:",
    boxesAmount: "VIP Passes amount:",
    featureCTA: "Join Waitlist",
    releaseCTA: "Notify Me",
    shopPageSoon: "Shop available soon",

    soldOut: "Sold Out",
    alreadySold: "Already Sold",
    secondaryMarketTitle: "Couldn't buy a pack here? Try the secondary market:",
    act1SecondaryMarketTitle: "Act One is available at secondary market:",
    act2SecondaryMarketTitle: "Act Two is available at secondary market:",

    openPack: "Open Asset",
    openPacks: "Open",
    openAndBurn: "Open and Burn",
    openPackConfirmation: "Are you sure you want to open {0} with mint {1}?",
    openPackSuccess: "Pack successfully opened!",

    goToPackRips: "Go To Pack Rips",
    noRips: "You don't have any opened pack yet.",
    viewRip: "View Rips",
    viewAsset: "View Asset",
    burn: "Burn Asset",
    burnConfirmationTitle: "Are you sure you want to burn the asset {0} with mint #{1}?",
    openAndBurnConfirmationTitle: "Are you sure you want to open and burn the asset {0} with mint #{1}?",
    burnConfirmationWarning: "Warning: burning assets is an irreversible action.",
    viewCollection: "You can also view your NFT collection on AtomicHub",
    viewEntireCollection: "View the entire Dark Pinup collection",
    recentItem: "New",
    expand: 'Expand',

    wax: "WAX",

    buyPacksFor: "Buy {0} packs for {1}",
    buyPackConfirmation: "Are you sure you want to buy one {0} for {1}?",
    buyPacksConfirmation: "Are you sure you want to buy {0} {1}s for a total of {2}?",
    packPurchaseLimit: "You can purchase up to {0} packs with credit card and up to 5 packs per minute with WAX.",

    successfulBuy: "Congratulations!",
    buySuccessMessage: "Your purchase has been successful. Check out your inventory.",

    assetNotMintedDisclaimer: "Mint number is being calculated...",
    packProbabilities: "{0} Probabilities",

    faqItems: [
        {
            question: "What is Dark Pinup?",
            answer: <>A brooding collection of portraiture done in Kommienezuspadt&apos;s signature style - diegetic lighting and cinematic frames that bring a beautiful new perspective to the world of pinup photography. Act 1 of Dark Pinup consists of 44 NFT photos as well as 44 mementos displayed across 8 rarity tiers. You can buy a physical copy of Lar&apos;s book <a href="https://workingclasspublishing.com/Dark-Pinup-by-Lars-Kommienezuspadt-p103651178" target='_blank' rel='noreferrer noopener'>here</a>.</>
        },
        {
            question: "What makes the Dark Pinup release unique?",
            answer: "Dark Pinup uses a best-in-class pre-mint pack opening system where probabilities are accurate and the mint number of your cards are randomized when opened. The probabilities between a single pack and a collector’s box are also consistent, with only the number of special mementos differing between the pack types. "
        },
        {
            question: "When does Dark Pinup release?",
            answer: "Dark Pinup will be available on May 19th at 6pm EST. It will be available until sold out or until the team decides to end the sale manually. Pack opening will commence one hour after launch, at 7pm EST. "
        },
        {
            question: "What are NFTs?",
            answer: <>NFT stands for Non Fungible Token and is a way of creating unique digital collectible assets. Refer to this article for more information on <a href='https://www.forbes.com/advisor/investing/nft-non-fungible-token/' target='_blank' rel='noreferrer noopener'>NFTs</a>.</>
        },
        {
            question: "What is WAX?",
            answer: <><a href='https://wax.io' target='_blank' rel='noreferrer noopener'>WAX</a> is a blockchain tailored for the end user experience with tools that allow collectors to buy, sell, and trade NFTs with ease. Since 2017, WAX has facilitated the trade of more than 100 million digital items.</>
        },
        {
            question: "What can I do with my Digital Collectible NFTs?",
            answer: <>NFTs can be traded, sold, collected, and otherwise enjoyed however the collector wants. Dark Pinup collectibles are unique and the images are stored on <a href='https://ipfs.io' target='_blank' rel='noreferrer noopener'>IPFS</a>, so your NFTs will exist forever in the growing WAX ecosystem. The story of Dark Pinup is just beginning to unfold - additional surprises, features, and releases are coming.</>
        },
        {
            question: "How can I buy Dark Pinup NFTs?",
            answer: <>You can buy Dark Pinup NFTs during the primary sales on darkpinup.com. Once the sale has concluded you can trade Dark Pinup on secondary markets including <a href='http://waxstash.com' target='_blank' rel='noreferrer noopener'>waxstash.com</a>, <a href='http://atomichub.io' target='_blank' rel='noreferrer noopener'>atomichub.io</a> and <a href='http://nfthive.io' target='_blank' rel='noreferrer noopener'>nfthive.io</a>.</>
        },
        {
            question: "Where can I see which Dark Pinup cards I own?",
            answer: <>You can refer to your inventory on the website or on your WAX Cloud Wallet <a href='https://all-access.wax.io/dashboard' target='_blank' rel='noreferrer noopener'>dashboard</a>.</>
        },
        {
            question: "Where can I see the entire Dark Pinup collection?",
            answer: <>You can see the entire Dark Pinup collection <a href='https://wax.atomichub.io/explorer/collection/darkpinup' target='_blank' rel='noreferrer noopener'>here</a>.</>
        },
        {
            question: "How do I redeem my Special Memento?",
            answer: "Please stay tuned for more information on how and where to redeem Special Mementos."
        },
        {
            question: "How can I buy WAX?",
            answer: <>WAXP is  available on <a href='https://bittrex.com/' target='_blank' rel='noreferrer noopener'>Bittrex</a> as well as <a href='http://kucoin.com' target='_blank' rel='noreferrer noopener'>Kucoin</a>. Learn more about where and how to buy WAXP <a href='https://eos-amsterdam.medium.com/the-complete-guide-to-the-wax-cloud-wallet-f14f95788012' target='_blank' rel='noreferrer noopener'>here</a>.</>
        },
        {
            question: "How do I know my NFTs are authentic?",
            answer: "Always refer to the verified checkmark on the collection to ensure your NFTS are created by DarkPinup and by the author DarkPinup ."
        },
        {
            question: "Is WAX bad for the environment?",
            answer: <>No, WAX is 125,000x more energy efficient than ETH as explained <a href='https://wax-io.medium.com/wax-celebrates-earth-month-9f3164749e46' target='_blank' rel='noreferrer noopener'>here</a>.</>
        },
        {
            question: "Who is FACINGS?",
            answer: "FACINGS is an NFT collection publishing platform. FACINGS puts everything you need to launch end-to-end NFT campaigns in one place, from payment processing to security- making it easier than ever before to integrate NFTs into your strategy."
        },
        {
            question: "Will there be additional features for Dark Pinup?",
            answer: "Hidden surprises also await those that choose to partake, including gamification features to be revealed post release."
        },
        {
            question: "Will the FACINGS team take the low mints?",
            answer: "No, the employees at FACINGS will not reserve low mint numbers. The team will hold 3% of the total pack supply for promotion and future use. "
        },
        {
            question: "How can I get support?",
            answer: <>Please email <a href='mailto:hello@facings.io'>hello@facings.io</a> for support.</>
        }

    ],

    howToBuy: {
        createWaxWallet: 'Create a WAX Cloud Wallet (WCW)',
        waxWalletDescription: 'The WAX Cloud Wallet is a lightweight and easy-to-use wallet account that you can use directly in your browser to hold and view your WAX NFTs. Instead of having to manage private keys, you can create a wallet with as little information as an email and password, or use any number of social accounts like Facebook and Twitter!',
        waxWalletButton: 'Create WAX Cloud Wallet',
        waxWalletLogin: 'Login Using Your New WCW',
        waxWalletLoginDescription: 'Use the "Log In" button in the top right or the button below to initialize your WAX Cloud Wallet on the The Strange and Unusual NFT website. A popup will appear and asking you to input your WCW information and authorize the login.',
        waxWalletLoginButton: "You're already logged in",
        packs: 'Purchase Your Packs',
        packsDescription: 'Go to the "Shop" page, select the number of packs you would like to purchase, then click "Buy Packs" Follow the onscreen prompts to fill out your credit or debt card information. Once you complete your purchase, it may take a few minutes for your packs to appear in your WCW.',
        openPacks: 'Open Packs and View NFTs',
        openPacksDescription: 'Use the navbar to open packs and view your NFTs! You can also trade your NFTs on secondary markets like AtomicHub!',
        openPacksButton: 'View Inventory'
    },

    redemption: 'Redemption',

    redeemAsset: "Redeem Asset",
    validateAddress: "Please validate your Address",
    fullName: "Full Name",
    email: "E-mail",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    addressLine4: "Address Line 4",
    city: "City",
    state: "State / Province / Region",
    country: "Country",
    zipCode: "ZIP Code / Postal Code",
    accountName: "ETH Wallet",

    customerFields: {
        accountName: "account_name",
        items: "items",
        email: "email"
    },

    addressFields: {
        fullName: "fullname",
        addressLine1: "line1",
        addressLine2: "line2",
        addressLine3: "line3",
        addressLine4: "line4",
        city: "city",
        state: "state",
        country: "country",
        zipCode: "zipcode",
        accountName: "account_name"
    },

    avataxAddressFields: {
        addressLine1: { key: "line1", label: "Line 1" },
        addressLine2: { key: "line2", label: "Line 2" },
        addressLine3: { key: "line3", label: "Line 3" },
        city: { key: "city", label: "City" },
        state: { key: "region", label: "State/Region" },
        country: { key: "country", label: "Country" },
        zipCode: { key: "postalCode", label: "ZIP/Postal Code" }
    },

    US: "United States of America",
    avataxCountryNotSupportedError: "Country not supported",

    countriesList: [{ "name": "Afghanistan" }, { "name": "Åland Islands" }, { "name": "Albania" }, { "name": "Algeria" }, { "name": "American Samoa" }, { "name": "Andorra" }, { "name": "Angola" }, { "name": "Anguilla" }, { "name": "Antarctica" }, { "name": "Antigua and Barbuda" }, { "name": "Argentina" }, { "name": "Armenia" }, { "name": "Aruba" }, { "name": "Australia" }, { "name": "Austria" }, { "name": "Azerbaijan" }, { "name": "Bahamas" }, { "name": "Bahrain" }, { "name": "Bangladesh" }, { "name": "Barbados" }, { "name": "Belarus" }, { "name": "Belgium" }, { "name": "Belize" }, { "name": "Benin" }, { "name": "Bermuda" }, { "name": "Bhutan" }, { "name": "Bolivia (Plurinational State of)" }, { "name": "Bonaire, Sint Eustatius and Saba" }, { "name": "Bosnia and Herzegovina" }, { "name": "Botswana" }, { "name": "Bouvet Island" }, { "name": "Brazil" }, { "name": "British Indian Ocean Territory" }, { "name": "United States Minor Outlying Islands" }, { "name": "Virgin Islands (British)" }, { "name": "Virgin Islands (U.S.)" }, { "name": "Brunei Darussalam" }, { "name": "Bulgaria" }, { "name": "Burkina Faso" }, { "name": "Burundi" }, { "name": "Cambodia" }, { "name": "Cameroon" }, { "name": "Canada" }, { "name": "Cabo Verde" }, { "name": "Cayman Islands" }, { "name": "Central African Republic" }, { "name": "Chad" }, { "name": "Chile" }, { "name": "China" }, { "name": "Christmas Island" }, { "name": "Cocos (Keeling) Islands" }, { "name": "Colombia" }, { "name": "Comoros" }, { "name": "Congo" }, { "name": "Congo (Democratic Republic of the)" }, { "name": "Cook Islands" }, { "name": "Costa Rica" }, { "name": "Croatia" }, { "name": "Cuba" }, { "name": "Curaçao" }, { "name": "Cyprus" }, { "name": "Czech Republic" }, { "name": "Denmark" }, { "name": "Djibouti" }, { "name": "Dominica" }, { "name": "Dominican Republic" }, { "name": "Ecuador" }, { "name": "Egypt" }, { "name": "El Salvador" }, { "name": "Equatorial Guinea" }, { "name": "Eritrea" }, { "name": "Estonia" }, { "name": "Ethiopia" }, { "name": "Falkland Islands (Malvinas)" }, { "name": "Faroe Islands" }, { "name": "Fiji" }, { "name": "Finland" }, { "name": "France" }, { "name": "French Guiana" }, { "name": "French Polynesia" }, { "name": "French Southern Territories" }, { "name": "Gabon" }, { "name": "Gambia" }, { "name": "Georgia" }, { "name": "Germany" }, { "name": "Ghana" }, { "name": "Gibraltar" }, { "name": "Greece" }, { "name": "Greenland" }, { "name": "Grenada" }, { "name": "Guadeloupe" }, { "name": "Guam" }, { "name": "Guatemala" }, { "name": "Guernsey" }, { "name": "Guinea" }, { "name": "Guinea-Bissau" }, { "name": "Guyana" }, { "name": "Haiti" }, { "name": "Heard Island and McDonald Islands" }, { "name": "Holy See" }, { "name": "Honduras" }, { "name": "Hong Kong" }, { "name": "Hungary" }, { "name": "Iceland" }, { "name": "India" }, { "name": "Indonesia" }, { "name": "Côte d'Ivoire" }, { "name": "Iran (Islamic Republic of)" }, { "name": "Iraq" }, { "name": "Ireland" }, { "name": "Isle of Man" }, { "name": "Israel" }, { "name": "Italy" }, { "name": "Jamaica" }, { "name": "Japan" }, { "name": "Jersey" }, { "name": "Jordan" }, { "name": "Kazakhstan" }, { "name": "Kenya" }, { "name": "Kiribati" }, { "name": "Kuwait" }, { "name": "Kyrgyzstan" }, { "name": "Lao People's Democratic Republic" }, { "name": "Latvia" }, { "name": "Lebanon" }, { "name": "Lesotho" }, { "name": "Liberia" }, { "name": "Libya" }, { "name": "Liechtenstein" }, { "name": "Lithuania" }, { "name": "Luxembourg" }, { "name": "Macao" }, { "name": "Macedonia (the former Yugoslav Republic of)" }, { "name": "Madagascar" }, { "name": "Malawi" }, { "name": "Malaysia" }, { "name": "Maldives" }, { "name": "Mali" }, { "name": "Malta" }, { "name": "Marshall Islands" }, { "name": "Martinique" }, { "name": "Mauritania" }, { "name": "Mauritius" }, { "name": "Mayotte" }, { "name": "Mexico" }, { "name": "Micronesia (Federated States of)" }, { "name": "Moldova (Republic of)" }, { "name": "Monaco" }, { "name": "Mongolia" }, { "name": "Montenegro" }, { "name": "Montserrat" }, { "name": "Morocco" }, { "name": "Mozambique" }, { "name": "Myanmar" }, { "name": "Namibia" }, { "name": "Nauru" }, { "name": "Nepal" }, { "name": "Netherlands" }, { "name": "New Caledonia" }, { "name": "New Zealand" }, { "name": "Nicaragua" }, { "name": "Niger" }, { "name": "Nigeria" }, { "name": "Niue" }, { "name": "Norfolk Island" }, { "name": "Korea (Democratic People's Republic of)" }, { "name": "Northern Mariana Islands" }, { "name": "Norway" }, { "name": "Oman" }, { "name": "Pakistan" }, { "name": "Palau" }, { "name": "Palestine, State of" }, { "name": "Panama" }, { "name": "Papua New Guinea" }, { "name": "Paraguay" }, { "name": "Peru" }, { "name": "Philippines" }, { "name": "Pitcairn" }, { "name": "Poland" }, { "name": "Portugal" }, { "name": "Puerto Rico" }, { "name": "Qatar" }, { "name": "Republic of Kosovo" }, { "name": "Réunion" }, { "name": "Romania" }, { "name": "Russian Federation" }, { "name": "Rwanda" }, { "name": "Saint Barthélemy" }, { "name": "Saint Helena, Ascension and Tristan da Cunha" }, { "name": "Saint Kitts and Nevis" }, { "name": "Saint Lucia" }, { "name": "Saint Martin (French part)" }, { "name": "Saint Pierre and Miquelon" }, { "name": "Saint Vincent and the Grenadines" }, { "name": "Samoa" }, { "name": "San Marino" }, { "name": "Sao Tome and Principe" }, { "name": "Saudi Arabia" }, { "name": "Senegal" }, { "name": "Serbia" }, { "name": "Seychelles" }, { "name": "Sierra Leone" }, { "name": "Singapore" }, { "name": "Sint Maarten (Dutch part)" }, { "name": "Slovakia" }, { "name": "Slovenia" }, { "name": "Solomon Islands" }, { "name": "Somalia" }, { "name": "South Africa" }, { "name": "South Georgia and the South Sandwich Islands" }, { "name": "Korea (Republic of)" }, { "name": "South Sudan" }, { "name": "Spain" }, { "name": "Sri Lanka" }, { "name": "Sudan" }, { "name": "Suriname" }, { "name": "Svalbard and Jan Mayen" }, { "name": "Swaziland" }, { "name": "Sweden" }, { "name": "Switzerland" }, { "name": "Syrian Arab Republic" }, { "name": "Taiwan" }, { "name": "Tajikistan" }, { "name": "Tanzania, United Republic of" }, { "name": "Thailand" }, { "name": "Timor-Leste" }, { "name": "Togo" }, { "name": "Tokelau" }, { "name": "Tonga" }, { "name": "Trinidad and Tobago" }, { "name": "Tunisia" }, { "name": "Turkey" }, { "name": "Turkmenistan" }, { "name": "Turks and Caicos Islands" }, { "name": "Tuvalu" }, { "name": "Uganda" }, { "name": "Ukraine" }, { "name": "United Arab Emirates" }, { "name": "United Kingdom of Great Britain and Northern Ireland" }, { "name": "United States of America" }, { "name": "Uruguay" }, { "name": "Uzbekistan" }, { "name": "Vanuatu" }, { "name": "Venezuela (Bolivarian Republic of)" }, { "name": "Viet Nam" }, { "name": "Wallis and Futuna" }, { "name": "Western Sahara" }, { "name": "Yemen" }, { "name": "Zambia" }, { "name": "Zimbabwe" }],

    successfulRedeem: "Congratulations!",
    redeemSuccessMessage: "The redeem request transaction has been sent. We will prepare your package and send you an email when we ship it.",
    redeemErrorMessage: "Your asset couldn't been redeemed, please try again later.",

    poweredByWax: "Powered by WAX",
    facingsLogo: "Built by FACINGS",
    atomicAssets: "Built with Atomic Assets",
    telegramLogo: 'FACINGS telegram group',
    twitterLogo: 'Twitter',
    facebookLogo: 'Facebook',
    waxLink: "https://wax.io",
    facingsLink: "https://facings.io",
    atomicLink: "https://wax.atomichub.io/explorer/collection/darkpinup",
    telegramLink: "https://t.me/facings",

    availableIn: "Available in",
    comingSoon: "Coming Soon",
    releaseDate: "November 30th",
    releaseTime: "12:00 AM PDT | 03:00 PM EDT | 08:00 PM UTC",
    actTwo: 'Act Two',

    formTitle: "Send us your email and get an exclusive Dark Pinup asset for free",
    formSuccessMessage: "We'll be sending you exclusive news about our releases",
    formButtonPreRelease: "Sign up for our newsletter",
    formButtonPostRelease: "Sign up for our newsletter",

    help: "Need Help?",
    helpFormTitle: "Having Trouble? Our Support Team Can Help!",

    privacyPolicy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    license: 'NFT License',

    leaderboardDescription: 'Those that achieve the highest ranks are given rewards that we will disclose at a later date. For now, the Leaderboard is a way to earn points and see where you rank in the Dark Pinup community.',
    pointsAwarded: 'Points Awarded:',
    pointsDescription: <>
        <ul style={{ padding: 0 }}>
            <li>Purchasing a Full Pack — 10 points</li>
            <li>Purchasing a Collector’s Box — 60 points</li>
            <li>Crafting an NFT — 1 point</li>
            <li>Opening a pack — 1 point</li>
        </ul>
    </>,

    cpuErrorMessage: <>Stake some CPU <a href={`/#${ROUTES.resources}`} target='_blank' rel='noreferrer noopener'>here</a> to solve the issue</>,
    netErrorMessage: <>Stake some NET <a href={`/#${ROUTES.resources}`} target='_blank' rel='noreferrer noopener'>here</a> to solve the issue</>,
    waxWallet: <>{"Don't have a WAX wallet yet? Create one "}<a href='https://wallet.wax.io' target='_blank' rel='noreferrer noopener'>here</a></>,

    vivaLeaderboard: {
        headline: 'Viva Event Leaderboard',
        title: 'VIVA EVENT IS NOW OVER',
        description: 'New Events coming soon!',
        earnPointsBy: 'Earn points by:',
        earnedPoints: 'Earned points:'
    },

    vivaPacksPage: {
        title: 'Viva Event Has Ended',
        cards: '20 new cards',
        rarity: 'Rarity Types',
        subtitle: 'Earn Free Packs!',
        earnVivaPacks: 'Earn Viva Packs',
        howToEarn: 'A month long event',
        viewLeaderboard: 'View Leaderboard',
        rarities: 'Two rarities - Base and Neon',
        onlyEarned: 'Only earned through the event',
        pointsDescription: 'For every 100 points, earn 1 Viva Pack*',
        newSet: 'A new set of Viva Las Vegas inspired cards in a pack of 3',
        description: '*airdropped at the conclusion of the event. 15 packs per account. The event will end if 5,260 packs are reached',
        pointsList: [
            { description: 'Purchase an Act 2 Full Pack', points: '10 points' },
            { description: 'Purchase a Collector’s Box', points: '60 points' },
            { description: 'Crafting any Dark Pinup NFT', points: '4 points' },
            { description: 'Opening any Dark Pinup NFT pack', points: '2 points' },
            { description: 'Burning any Dark Pinup NFT', points: '2 points' }
        ]
    }
};

export default STRINGS;
